import { type FC } from 'react';
import { useWatchNewPayoutTickets } from '~/features/payout';

export const PayoutTicketsWatcher: FC = () => {
    useWatchNewPayoutTickets();

    return null;
};
